import { render } from "./InputDatalist.vue?vue&type=template&id=cdba0c82&scoped=true"
import script from "./InputDatalist.vue?vue&type=script&lang=js"
export * from "./InputDatalist.vue?vue&type=script&lang=js"

import "./InputDatalist.vue?vue&type=style&index=0&id=cdba0c82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cdba0c82"

export default script